export class Usuario {
public USER_ID: number;
public email: string;
public contrasenia: string;
public loacs: any;
public USER_NAME: string;
public ECRYPTED_PASSWORD: string;
public ECRYPTED_ANSWER: string;
public ECRYPTED_FOUNDATION: string;
public ASK_ID: number;
public DESCRIPTION: string;
public PASSWORD_LIFE_DATE: number;
public PERSON_ID: number;
public EMAIL: string;
public PASSWORD_DATE: any;
public COMPANY_ID: number;
public ORGANIZATION_ID: number;
public ADMIN: number;
}



// WEBPACK FOOTER //
// ./src/app/models/usuario.ts